import tseInstance from '../instance'

const getTseNotification = () => {
	return tseInstance.get('/company/tse/notification')
}

export default getTseNotification
